import { TColor } from "@/api/v1_0";
import keys from "lodash/keys";

export namespace Color {
  export const colors: Array<TColor> = [
    TColor.ValueE22C2C,
    TColor.ValueF56514,
    TColor.ValueF58E14,
    TColor.ValueFFB800,
    TColor.ValueABD15B,
    TColor.Value9BB437,
    TColor.Value7DB437,
    TColor.Value2686DF,
    TColor.Value4899B2,
    TColor.Value6EAEEA,
    TColor.Value6E89EA,
    TColor.Value4869DC,
    TColor.Value8948DC,
    TColor.ValueC762D8,
    TColor.ValueE17DB9,
    TColor.Value333333,
  ];

  export type ISchemaColor =
    | TColor.ValueE22C2C
    | TColor.ValueF56514
    | TColor.ValueF58E14
    | TColor.ValueFFB800
    | TColor.ValueABD15B
    | TColor.Value9BB437
    | TColor.Value7DB437
    | TColor.Value2686DF
    | TColor.Value4899B2
    | TColor.Value6EAEEA
    | TColor.Value6E89EA
    | TColor.Value4869DC
    | TColor.Value8948DC
    | TColor.ValueC762D8
    | TColor.ValueE17DB9
    | TColor.Value333333;

  export interface ISchema {
    gradient: Array<string>;
    lightBackground: string;
  }

  type ISchemas = { [key in ISchemaColor]: ISchema };

  export const schemas: ISchemas = {
    "#E22C2C": {
      gradient: ["#E22C2C99", "#E22C2C"],
      lightBackground: "#E22C2C30",
    },
    "#F56514": {
      gradient: ["#F5651499", "#F56514"],
      lightBackground: "#F5651430",
    },
    "#F58E14": {
      gradient: ["#F58E1499", "#F58E14"],
      lightBackground: "#F58E1430",
    },
    "#FFB800": {
      gradient: ["#FFB80099", "#FFB800"],
      lightBackground: "#FFB80030",
    },
    "#ABD15B": {
      gradient: ["#ABD15B99", "#ABD15B"],
      lightBackground: "#ABD15B30",
    },
    "#9BB437": {
      gradient: ["#9BB43799", "#9BB437"],
      lightBackground: "#9BB43730",
    },
    "#7DB437": {
      gradient: ["#7DB43799", "#7DB437"],
      lightBackground: "#7DB43730",
    },
    "#2686DF": {
      gradient: ["#2686DF99", "#2686DF"],
      lightBackground: "#2686DF30",
    },
    "#4899B2": {
      gradient: ["#4899B299", "#4899B2"],
      lightBackground: "#4899B230",
    },
    "#6EAEEA": {
      gradient: ["#6EAEEA99", "#6EAEEA"],
      lightBackground: "#6EAEEA30",
    },
    "#6E89EA": {
      gradient: ["#6E89EA99", "#6E89EA"],
      lightBackground: "#6E89EA30",
    },
    "#4869DC": {
      gradient: ["#4869DC99", "#4869DC"],
      lightBackground: "#4869DC30",
    },
    "#8948DC": {
      gradient: ["#8948DC99", "#8948DC"],
      lightBackground: "#8948DC30",
    },
    "#C762D8": {
      gradient: ["#C762D899", "#C762D8"],
      lightBackground: "#C762D830",
    },
    "#E17DB9": {
      gradient: ["#E17DB999", "#E17DB9"],
      lightBackground: "#E17DB930",
    },
    "#333333": {
      gradient: ["#33333399", "#333333"],
      lightBackground: "#33333330",
    },
  };

  export const schemasKeys = keys(schemas);
}
